module.exports = __webpack_public_path__ + "img/Icon_no_internet.77425c92.png";